import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '../components/login/LoginForm';
import { InputField } from '../components/login/InputField';
import { LoginButton } from '../components/login/LoginButton';

const Register: React.FC = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!username || !email || !password || !confirm) {
      setError('Preencha todos os campos.');
      return;
    }
    if (password !== confirm) {
      setError('As senhas não coincidem.');
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate('/login');
    }, 1200);
  };

  return (
    <LoginForm onSubmit={handleSubmit}>
      <div style={{ marginBottom: 24 }}>
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect width="48" height="48" rx="12" fill="#EEF0FF" /><path d="M16 32L24 24L32 32" stroke="#2D4BFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 24L24 16L32 24" stroke="#2D4BFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </div>
      <h2 style={{ fontWeight: 700, fontSize: 24, margin: 0, marginBottom: 4, color: '#222' }}>Criar Conta</h2>
      <div style={{ color: '#6B7280', fontSize: 15, marginBottom: 28 }}>Preencha os dados para registrar</div>
      {error && (
        <div style={{ color: '#F44336', background: '#FFF0F0', borderRadius: 6, padding: '8px 12px', marginBottom: 16, width: '100%', textAlign: 'center', fontSize: 15 }}>
          {error}
        </div>
      )}
      <InputField
        label="Usuário"
        type="text"
        value={username}
        onChange={setUsername}
        onBlur={() => { }}
        placeholder="Digite seu usuário"
        icon={<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 0 0-8 0v2" /><circle cx="12" cy="7" r="4" /></svg>}
      />
      <InputField
        label="E-mail"
        type="email"
        value={email}
        onChange={setEmail}
        onBlur={() => { }}
        placeholder="Digite seu e-mail"
        icon={<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M2 7l10 7 10-7" /></svg>}
      />
      <InputField
        label="Senha"
        type={showPassword ? 'text' : 'password'}
        value={password}
        onChange={setPassword}
        onBlur={() => { }}
        placeholder="Digite sua senha"
        icon={<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="8" rx="4" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>}
        showPasswordToggle
        onTogglePassword={() => setShowPassword(s => !s)}
        showPassword={showPassword}
      />
      <InputField
        label="Confirmar Senha"
        type={showPassword ? 'text' : 'password'}
        value={confirm}
        onChange={setConfirm}
        onBlur={() => { }}
        placeholder="Confirme sua senha"
        icon={<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="8" rx="4" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>}
        showPasswordToggle
        onTogglePassword={() => setShowPassword(s => !s)}
        showPassword={showPassword}
      />
      <LoginButton loading={loading} text="Criar" />
      <div style={{ color: '#6B7280', fontSize: 13, marginTop: 24, textAlign: 'center' }}>
        Já possui conta? <a href="/login" style={{ color: '#2D4BFF', textDecoration: 'none', fontWeight: 500 }}>Entrar</a>
      </div>
    </LoginForm>
  );
};

export default Register;